import React from 'react';
import { FiCrisisPayload } from '../../contexts/fi-context';
import { ResourceTile } from '../resource-tile';
import { CrisisResourceSectionTitle } from '../crisis-resource-section-title';

interface FiCrisisMessageProps {
  crisis: FiCrisisPayload;
  onDismiss: () => void;
}

export const FiCrisisMessage: React.FC<FiCrisisMessageProps> = ({ crisis, onDismiss }) => {
  const { emergency, crisisResource } = crisis;
  return (
    <div className={`rounded-xl border p-4 ${emergency ? 'border-red-200 bg-red-50' : 'border-blue-200 bg-blue-50'}`}>
      <p className="font-albert-sans text-sm font-semibold text-gray-900">
        {emergency ? 'Crisis support' : "We're here to help"}
      </p>
      {emergency ? (
        <p className="font-open-sans mt-2 text-sm text-red-900">
          If you are in immediate danger, call 911. Crisis counselors are available 24/7.
        </p>
      ) : (
        <p className="font-open-sans mt-2 text-sm text-gray-800">
          It looks like you might be going through a difficult time. Professional crisis counselors are available 24/7.
        </p>
      )}
      <div className="mt-3 flex flex-col gap-2">
        {emergency && (
          <button
            type="button"
            onClick={() => window.open('tel:911')}
            className="font-albert-sans rounded-full bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
          >
            Call 911
          </button>
        )}
        <button
          type="button"
          onClick={() => window.open('tel:988')}
          className="font-albert-sans bg-button-primary hover:bg-button-primary-hover rounded-full px-4 py-2 text-sm font-medium text-white"
        >
          Call 988 Lifeline
        </button>
        <button
          type="button"
          onClick={() => window.open('sms:741741?body=HOME')}
          className="font-albert-sans border-input-border-gray rounded-full border bg-white px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50"
        >
          Text HOME to 741741
        </button>
        {!emergency && (
          <button
            type="button"
            onClick={() => window.open('https://988lifeline.org/chat/')}
            className="font-albert-sans border-input-border-gray rounded-full border bg-white px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50"
          >
            Chat online
          </button>
        )}
      </div>
      {crisisResource ? (
        <div className="mt-3 flex w-full flex-col">
          <CrisisResourceSectionTitle
            emergency={emergency}
            imageUrl={crisisResource.image_url || crisisResource.wide_image_url}
          />
          <div className="flex justify-center">
            <ResourceTile resource={crisisResource} centered />
          </div>
        </div>
      ) : null}
      <button type="button" onClick={onDismiss} className="font-open-sans mt-3 text-sm text-gray-500 hover:underline">
        Dismiss
      </button>
    </div>
  );
};
